module.exports = __webpack_public_path__ + "static/media/next-circle-disabled.8fa025b2.png";